var _a;
import { ThemeBreakpoints } from '../../breakpoints';
var horizontalWizardActive = (_a = {},
    _a[ThemeBreakpoints.MOBILE] = {
        width: '288px',
        borderRadius: '24px',
        paddingRight: '8px',
    },
    _a[ThemeBreakpoints.SMALL] = {
        width: '288px',
        borderRadius: '24px',
        paddingRight: '8px',
    },
    _a[ThemeBreakpoints.MEDIUM] = {
        width: '288px',
        borderRadius: '24px',
        paddingRight: '8px',
    },
    _a[ThemeBreakpoints.LARGE] = {
        width: '288px',
        borderRadius: '24px',
        paddingRight: '8px',
    },
    _a);
export default horizontalWizardActive;
